import { supabase } from '@lib/supabase';

export interface AuthTokenResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: string;
    email?: string;
    user_metadata?: Record<string, unknown>;
  };
}

/**
 * Get the current user's ID from Supabase as session ID
 * Works for both authenticated and anonymous users
 */
export const getUserId = async () => {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user?.id) {
    console.error(
      'getUserId: No user found (neither authenticated nor anonymous)'
    );
    throw new Error('No user found (neither authenticated nor anonymous)');
  }

  return user.id;
};
